export default {
  barGraph: {
    prettyName: 'Bar Graph Panel',
    tag: '<bar-graph-panel panel-id="::pc3PanCtrl.panel.id"></bar-graph-panel>',
    description: 'Displays a bar graph representation of events/datapoints.',
    allowedEquipmentTypes: ['sensors', 'tanks'],
    getDefaultPanelConfigPerEquipment: getDefaultConfig,
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 12,
        sizeY: 7,
        minSizeX: 12,
        minSizeY: 5,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 12,
        sizeY: 3,
        minSizeX: 12,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    },
  },
  cameras: {
    prettyName: 'Camera Panel',
    tag: '<camera-panel ng-cloak panel-id="::pc3PanCtrl.panel.id"></camera-panel>',
    description: 'Panel used for viewing live feeds of cameras, as well as adjusting settings on a camera. ' +
      'NOTE: set the property "adminOnlySettings": true in the panel config to restrict ' +
      'the settings modal to only admin level users.',
    allowedEquipmentTypes: ['cameras', 'radar'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 4,
        sizeY: 4,
        minSizeX: 4,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 4,
        sizeY: 4,
        minSizeX: 4,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 3,
        sizeY: 3,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  equipmentMap: {
    prettyName: 'Equipment Map Panel',
    tag: '<equipment-map panel-id="::pc3PanCtrl.panel.id"></equipment-map>',
    description: `
       Shows the location of an equipment on a map. Pins will update in real time if the equipment's
       location is configured to update.
      `,
    allowedEquipmentTypes: [],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 15,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 5,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 10,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 10,
        sizeY: 4,
        minSizeX: 6,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  events: {
    prettyName: 'Events Panel',
    tag: '<events-panel panel-id="::pc3PanCtrl.panel.id"></events-panel>',
    description: 'This panel shows the events for the equipments that are assigned to the panel.',
    allowedEquipmentTypes: [],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 9,
        minSizeX: 12,
        minSizeY: 9,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 7,
        sizeY: 4,
        minSizeX: 6,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 4,
        sizeY: 3,
        minSizeX: 5,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  gasMeter: {
    prettyName: 'Gas Meter Panel',
    tag: '<gas-meter-panel panel-id="::pc3PanCtrl.panel.id"></gas-meter-panel>',
    description: 'This panel shows the gas meter read out for assigned equipment.',
    allowedEquipmentTypes: ['sensors'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 4,
        minSizeX: 12,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 4,
        minSizeX: 12,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 12,
        sizeY: 2,
        minSizeX: 12,
        minSizeY: 2,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 12,
        sizeY: 2,
        minSizeX: 8,
        minSizeY: 2,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  gates: {
    prettyName: 'Gate Panel',
    tag: '<dial-panel panel-id="::pc3PanCtrl.panel.id"></dial-panel>',
    description: 'Panel for controlling that state of gate equipments.',
    allowedEquipmentTypes: ['gates'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 6,
        sizeY: 6,
        minSizeX: 6,
        minSizeY: 6,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 6,
        sizeY: 6,
        minSizeX: 5,
        minSizeY: 5,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 4,
        sizeY: 4,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  generic: {
    prettyName: 'Generic Panel',
    tag: '<generic-panel panel-id="::pc3PanCtrl.panel.id"></generic-panel>',
    description: 'Panel used to view generic settings.',
    allowedEquipmentTypes: [],
    getDefaultPanelConfigPerEquipment() {
      return {
        statusesToShow: [],
        excludeFromPanel: [],
        listenForEvent: ''
      };
    },
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 4,
        sizeY: 4,
        minSizeX: 4,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 3,
        sizeY: 3,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  graphs: {
    prettyName: 'Graph Panel',
    tag: '<graph-panel panel-id="::pc3PanCtrl.panel.id"></graph-panel>',
    description: 'This panel is an agnostic graph panel that will use the "listenForEvent" property ' +
      'for each equipment in the config to graph the retrieved data points. If no "listenForEvent" is specified, ' +
      'or it is an empty string (e.g. ""), it will pull all of the events for the equipment ' +
      'within the "daysOfDataToPull" time period and graph them.',
    allowedEquipmentTypes: [],
    getDefaultPanelConfigPerEquipment: getDefaultConfig,
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 7,
        minSizeX: 12,
        minSizeY: 7,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 5,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 10,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 10,
        sizeY: 4,
        minSizeX: 6,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  monitoringActions: {
    prettyName: 'Monitoring Actions Panel',
    tag: '<monitoring-actions-panel panel-id="::pc3PanCtrl.panel.id"></monitoring-actions-panel>',
    description: 'This panel is used for the manned monitoring center to allow them ' +
      'to take given actions on assigned equipment.',
    allowedEquipmentTypes: [],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 9,
        minSizeX: 12,
        minSizeY: 9,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 7,
        sizeY: 4,
        minSizeX: 6,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 4,
        sizeY: 3,
        minSizeX: 5,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  padlocks: {
    prettyName: 'SmartLock Panel',
    tag: '<smartlock-panel panel-id="::pc3PanCtrl.panel.id"></smartlock-panel>',
    description: 'This panel is used for displaying information about assigned Smartlocks.',
    // this object specifies which types of equipment are allowed to be assigned to this particular
    // panel type. Set the equipmentType to a value of 'true' to allow the panel to have this
    // type of equipment
    allowedEquipmentTypes: ['padlocks'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 9,
        minSizeX: 12,
        minSizeY: 9,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 7,
        sizeY: 4,
        minSizeX: 6,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 4,
        sizeY: 3,
        minSizeX: 5,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  pumps: {
    prettyName: 'Dial Panel',
    tag: '<dial-panel panel-id="::pc3PanCtrl.panel.id"></dial-panel>',
    description: 'Panel with a dial-knob to send actions to associated equipment.',
    allowedEquipmentTypes: ['pumps', 'gates', 'accessControls', 'genetec'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 12,
        minSizeX: 12,
        minSizeY: 12,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 6,
        sizeY: 6,
        minSizeX: 6,
        minSizeY: 6,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 6,
        sizeY: 5,
        minSizeX: 6,
        minSizeY: 5,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 3,
        sizeY: 3,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  tanks: {
    prettyName: 'Tank Panel',
    tag: '<tank-panel panel-id="::pc3PanCtrl.panel.id"></tank-panel>',
    description: 'Panel to display individual readings of assigned equipment, ' +
      'as well as a summary of all tanks assigned to the panel.',
    allowedEquipmentTypes: ['tanks'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 12,
        minSizeX: 12,
        minSizeY: 12,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 6,
        minSizeY: 6,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 11,
        sizeY: 6,
        minSizeX: 11,
        minSizeY: 6,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 12,
        sizeY: 6,
        minSizeX: 6,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  totalFlowMeters: {
    prettyName: 'Total Flow Panel',
    tag: '<graph-panel panel-id="::pc3PanCtrl.panel.id"></graph-panel>',
    description: 'Panel that allows user to graph different values of the assigned Total Flow equipment.',
    allowedEquipmentTypes: ['totalFlowMeters'],
    getDefaultPanelConfigPerEquipment: getDefaultConfig,
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 7,
        minSizeX: 12,
        minSizeY: 7,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 5,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 10,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 10,
        sizeY: 4,
        minSizeX: 6,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  tripwires: {
    prettyName: 'Tripwire Panel',
    tag: '<trip-wire panel-id="::pc3PanCtrl.panel.id"></trip-wire>',
    allowedEquipmentTypes: ['tripwires', 'cameras'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 7,
        minSizeX: 12,
        minSizeY: 7,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 5,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 10,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 10,
        sizeY: 4,
        minSizeX: 6,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  status: {
    prettyName: 'Status Panel',
    tag: '<status-panel panel-id="::pc3PanCtrl.panel.id"></status-panel>',
    allowedEquipmentTypes: ['sensors'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 4,
        sizeY: 4,
        minSizeX: 4,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 3,
        sizeY: 3,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  weather: {
    prettyName: 'Disable Events Panel',
    tag: '<weather-panel panel-id="::pc3PanCtrl.panel.id"></weather-panel>',
    description: 'This panel allows the user to disable events for equipment for a specified duration.',
    allowedEquipmentTypes: [],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 9,
        minSizeX: 12,
        minSizeY: 9,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 7,
        sizeY: 4,
        minSizeX: 6,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 4,
        sizeY: 3,
        minSizeX: 5,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  shutoffThreshold: {
    prettyName: 'Shutoff Threshold Panel',
    tag: '<shutoff-panel panel-id="::pc3PanCtrl.panel.id"></shutoff-panel>',
    description: 'Panel used to view the current readings of the shutoff equipment, as well as set new thresholds.',
    allowedEquipmentTypes: ['shutoff'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 10,
        minSizeX: 12,
        minSizeY: 10,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 5,
        sizeY: 5,
        minSizeX: 4,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 4,
        sizeY: 4,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  voiceDown: {
    prettyName: 'Voice Down Panel',
    tag: '<voice-down-panel panel-id="::pc3PanCtrl.panel.id"></voice-down-panel>',
    description: 'This panel shows a list of recordings to play through your speakers.',
    allowedEquipmentTypes: ['speakers'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 8,
        minSizeX: 12,
        minSizeY: 8,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 6,
        sizeY: 4,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 4,
        sizeY: 4,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    }
  },
  portal: {
    prettyName: 'Portal Panel',
    tag: '<portal-panel panel-id="::pc3PanCtrl.panel.id"></portal-panel>',
    description: 'This panel provides a view of external resources.',
    allowedEquipmentTypes: ['portals'],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 8,
        minSizeX: 12,
        minSizeY: 8,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 6,
        sizeY: 4,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 4,
        sizeY: 4,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      }
    },
  },
  site: {
    prettyName: 'Site Panel',
    tag: '<site-panel panel-id="::pc3PanCtrl.panel.id"></site-panel>',
    description: 'This panel provides a site overview.',
    allowedEquipmentTypes: [],
    modes: {
      mobile: {
        sizeX: 12,
        sizeY: 8,
        minSizeX: 12,
        minSizeY: 8,
        maxSizeX: 12,
        maxSizeY: 100
      },
      smallTablet: {
        sizeX: 12,
        sizeY: 4,
        minSizeX: 8,
        minSizeY: 4,
        maxSizeX: 12,
        maxSizeY: 100
      },
      largeTablet: {
        sizeX: 6,
        sizeY: 4,
        minSizeX: 3,
        minSizeY: 3,
        maxSizeX: 12,
        maxSizeY: 100
      },
      desktop: {
        sizeX: 8,
        sizeY: 5,
        minSizeX: 7,
        minSizeY: 5,
        maxSizeX: 12,
        maxSizeY: 100
      }
    },
  }
};

function getDefaultConfig(equipment) {
  const defaultConfig = {
    listenForEvent: '',
    numberOfDigits: 4,
    daysOfDataToPull: 7,
    performDataDownsampling: false,
    graphByDefault: [],
    includeInGraph: [],
    excludeFromGraph: [],
    drawPoints: true,
    highlightCircleSize: 5,
    strokeWidth: 1,
    pointSize: 2,
    stepPlot: false
  };
  const configAlterations = {
    cameras() {
      defaultConfig.listenForEvent = 'cameras/cameraAudioRegularUpdate';
      defaultConfig.graphByDefault.push('decibel');
      defaultConfig.excludeFromGraph.push('media');
    },
    sensors() {
      defaultConfig.listenForEvent = 'sensors/regularUpdate';
    },
    shutoff() {
      defaultConfig.listenForEvent = 'shutoff/shutoffRegularUpdate';
      defaultConfig.graphByDefault.push('currentReading');
    },
    tanks() {
      defaultConfig.listenForEvent = 'tanks/regularUpdate';
      defaultConfig.graphByDefault.push('topLevel', 'waterLevel');
      defaultConfig.excludeFromGraph.push(
        'inchesToBarrels',
        'correctionFactor',
        'highLevel',
        'criticalLevel',
        'rapidIncrease',
        'rapidDecrease',
        'sizeInInches'
      );
      defaultConfig.stepPlot = false;
    },
    totalFlowMeters() {
      defaultConfig.listenForEvent = 'totalFlowMeters/totalFlowMeterRegularUpdate';
      defaultConfig.graphByDefault.push(
        'accumulatedVolume',
        'volumeFlowRate',
        'todayVolume',
        'staticPressure'
      );
    }
  };
  if (_.has(configAlterations, equipment.equipmentType)) {
    configAlterations[equipment.equipmentType]();
  }
  return defaultConfig;
}
